export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_28-5e551b96243cd407db6cff57a21c1526.jpg";